import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { updateSupplementalQuestionsOrder } from "~/providers/api";
import { supplementalQuestionsQueryOptionsFactory } from "~/providers/factories/supplementalQuestionsQueryOptionsFactory";

export const useUpdateSupplementalQuestionsOrder = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateSupplementalQuestionsOrder,
    onError: () =>
      toast.error(
        "There was an issue updating the questions order. Please try again later.",
      ),
    onSuccess: () => {
      queryClient
        .invalidateQueries({
          queryKey: supplementalQuestionsQueryOptionsFactory.list._def,
          exact: false,
        })
        .catch(() => {
          toast.error("Failed to refresh questions data.");
        });
    },
  });
};
